// fullFaceBotoxData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const lipFlipBotox: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Botox Lip Flip Treatment in Dubai | Fuller, Defined Lips",
            "description": "Botox Lip Flip in Dubai for fuller, beautifully enhanced lips. Achieve a subtle lift and definition with expert care. Book your consultation today!",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/botox-lip-flip/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Botox Lip Flip Treatment in Dubai | Fuller, Defined Lips",
                "description": "Botox Lip Flip in Dubai for fuller, beautifully enhanced lips. Achieve a subtle lift and definition with expert care. Book your consultation today!",
                "url": "https://elitebodyhome.com/botox-lip-flip/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T10:42:55+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-58.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-58.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "botox lip flip",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Botox Lip Flip Treatment in Dubai | Fuller, Defined Lips",
                "description": "Botox Lip Flip in Dubai for fuller, beautifully enhanced lips. Achieve a subtle lift and definition with expert care. Book your consultation today!",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-58.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Botox Lip Flip"],
        "hero": {
            "title": "Botox Lip Flip",
            "subtitle": "Add a Little Lift to Your Smile",
            "description": "Get a flawlessly improved smile at Elite Body Home with the Botox Lip Flip. By relaxing the muscles surrounding your mouth, this non-invasive procedure gently improves the curve of your lips, giving you a fuller and more defined appearance."
        },
        "howItWorks": {
            "title": "What is a Botox Lip Flip?",
            "description": "A common non-surgical cosmetic procedure that gives your lips a larger, more defined appearance is the Botox Lip Flip. In contrast to conventional lip fillers, this procedure entails a little Botox injection into the muscles surrounding the upper lip. Without increasing volume, the outcome is a delicate 'flip' of the lip that gives the appearance of being naturally fuller and enhanced."
        },
        "procedureSteps": {
            "heading": "Steps for the Botox Lip Flip Procedure",
            "para": "",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "A thorough consultation with our knowledgeable practitioner is the first step in your journey. To make sure the Botox Lip Flip is the best course of action for you, we evaluate your lip shape, facial structure, and desired result.",
                    "icon": "fa-regular fa-comment"
                },
                {
                    "title": "Getting ready",
                    "desc": "Although most patients find the process to be almost painless and may not need any numbing, the treatment area is cleaned and a numbing cream may be applied to assure your comfort.",
                    "icon": "fa-regular fa-hand-sparkles"
                },
                {
                    "title": "Injections of Botox",
                    "desc": "Small doses of Botox are delicately injected into particular muscles surrounding your upper lip using a tiny needle. Because the muscles are relaxed, the lip can easily 'flip' outward to appear bigger.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Aftercare",
                    "desc": "You might have some moderate redness or swelling after the injections, but these side effects normally go away in a few hours. To guarantee the greatest outcomes and a speedy recovery, you will receive post-treatment instructions.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "benefits": {
            "heading": "Key Benefits of Botox Lip Flip",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "Results That Look Natural",
                    "desc": "By enhancing your lips without increasing volume, the Botox Lip Flip gives them a more understated and organic look.",
                    "icon": "fa-regular fa-face-smile"
                },
                {
                    "title": "Fast Process",
                    "desc": "The procedure is perfect for people with hectic schedules because it takes less than fifteen minutes.",
                    "icon": "fa-regular fa-clock"
                },
                {
                    "title": "Very little downtime",
                    "desc": "With only minor swelling or redness that goes away in a few hours, you can immediately return to your regular activities following the procedure.",
                    "icon": "fa-solid fa-bed"
                },
                {
                    "title": "Inexpensive Substitute",
                    "desc": "Compared to dermal fillers, the Botox Lip Flip is a less expensive choice for people looking for a slight augmentation.",
                    "icon": "fa-solid fa-coins"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Most adults looking for a minor lip enhancement can benefit from the Botox Lip Flip. Nonetheless, some people may be a better candidate for this surgery than others due to specific characteristics.",
            "items": [
                {
                    "title": "Ideal Candidates",
                    "desc": "People with thin lips, those who wish to remedy a 'gummy' grin, and those who just want a little lift without adding volume.",
                    "icon": "fa-solid fa-user-check"
                },
                {
                    "title": "Not Suitable For",
                    "desc": "People who are pregnant or nursing, or who have specific medical issues.",
                    "icon": "fa-solid fa-ban"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "The Botox Lip Flip is easy to prepare for and takes little work. Avoiding some drugs and supplements prior to the treatment is crucial since they can thin the blood and raise the risk of bruises.",
            "items": [
                {
                    "title": "Avoid Blood Thinners",
                    "desc": "Aspirin and ibuprofen are blood thinners that should be avoided at least 48 hours prior to treatment.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Lifestyle Adjustments",
                    "desc": "Avoid drinking alcohol and smoking before the surgery.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "Disclose Medications",
                    "desc": "Any medications or supplements you are taking should be disclosed to your doctor.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "Come Prepared",
                    "desc": "Make sure your face is clean and free of makeup when you arrive at your appointment.",
                    "icon": "fa-solid fa-broom"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "A Botox Lip Flip produces a more defined and improved top lip with subtle yet effective results. A more youthful appearance is produced by the lip's soft outward flip and increased fullness.",
            "items": [
                {
                    "title": "Duration",
                    "desc": "The effects typically last three to four months.",
                    "icon": "fa-regular fa-calendar"
                },
                {
                    "title": "Maintenance",
                    "desc": "Maintenance treatments can be planned to extend the effects.",
                    "icon": "fa-solid fa-arrows-rotate"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Tips",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "Avoid Touching the Area",
                    "desc": "To stop the Botox from spreading to unwanted muscles, avoid touching, rubbing, or massaging the treated area for at least 24 hours.",
                    "icon": "fa-solid fa-hand-paper"
                },
                {
                    "title": "Remain Upright",
                    "desc": "To give the Botox time to fully settle, avoid leaning over or lying down for at least four hours following the procedure.",
                    "icon": "fa-solid fa-person"
                },
                {
                    "title": "Limit Physical Activity",
                    "desc": "To lower the chance of swelling or bruising at the injection sites, avoid strenuous exercise or physical activity during the first 24 hours.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "No Hot Environments",
                    "desc": "For 24 hours, stay away from hot showers, saunas, and other heat sources as heat might deteriorate the effects by causing the Botox to spread.",
                    "icon": "fa-solid fa-temperature-high"
                },
                {
                    "title": "Avoid Alcohol and Blood Thinners",
                    "desc": "To reduce the chance of bruises, abstain from alcohol consumption and blood-thinning drugs (such ibuprofen or aspirin) for 24 hours.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Maintain Hydration",
                    "desc": "To aid in the healing process and maintain proper hydration, drink lots of water.",
                    "icon": "fa-solid fa-glass-water"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How soon will I see results?",
                    "answer": "Results from the Botox Lip Flip typically begin to appear within 3-4 days, with full effects visible after about a week."
                },
                {
                    "question": "Is there any downtime?",
                    "answer": "No, the procedure has minimal downtime. You may experience slight swelling or redness, but this subsides within a few hours."
                },
                {
                    "question": "Will it affect my ability to speak or eat?",
                    "answer": "No, the Botox Lip Flip targets only specific muscles around the lip and will not affect your ability to speak, eat, or smile."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/ebh-services-uae-33-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Botox-Lip-Flip-Dubai-3.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Botox-Lip-Flip-Dubai-1.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Botox-Lip-Flip-Dubai-2.jpg"
            ],
        },
        "product": {
            "id": 5,
            "title": "Botox Lip Flip",
            "price": 199,
            "description": "Get a flawlessly improved smile at Elite Body Home with the Botox Lip Flip. By relaxing the muscles surrounding your mouth, this non-invasive procedure gently improves the curve of your lips, giving you a fuller and more defined appearance."
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "علاج بوتوكس قلب الشفاه في دبي | شفاه ممتلئة ومحددة",
            "description": "بوتوكس قلب الشفاه في دبي للحصول على شفاه ممتلئة ومحسنة بشكل جميل. حقق رفعًا وتحديدًا دقيقًا مع رعاية خبراء. احجز استشارتك اليوم!",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/botox-lip-flip/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "علاج بوتوكس قلب الشفاه في دبي | شفاه ممتلئة ومحددة",
                "description": "بوتوكس قلب الشفاه في دبي للحصول على شفاه ممتلئة ومحسنة بشكل جميل. حقق رفعًا وتحديدًا دقيقًا مع رعاية خبراء. احجز استشارتك اليوم!",
                "url": "https://elitebodyhome.com/botox-lip-flip/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T10:42:55+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-58.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-58.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "بوتوكس قلب الشفاه",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "علاج بوتوكس قلب الشفاه في دبي | شفاه ممتلئة ومحددة",
                "description": "بوتوكس قلب الشفاه في دبي للحصول على شفاه ممتلئة ومحسنة بشكل جميل. حقق رفعًا وتحديدًا دقيقًا مع رعاية خبراء. احجز استشارتك اليوم!",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-58.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "بوتوكس قلب الشفاه"],
        "hero": {
            "title": "بوتوكس قلب الشفاه",
            "subtitle": "أضف لمسة من الجاذبية لابتسامتك",
            "description": "احصل على ابتسامة أكثر جمالًا مع بوتوكس قلب الشفاه في ايليت بودي هوم. يعمل هذا الإجراء غير الجراحي على إرخاء العضلات المحيطة بالفم، مما يساعد على إبراز منحنى الشفاه بلطف، لمنحها مظهرًا أكثر امتلاءً وتحديدًا دون زيادة في الحجم."
        },
        "howItWorks": {
            "title": "ما هو بوتوكس قلب الشفاه؟",
            "description": "يُعد بوتوكس قلب الشفاه إجراء تجميلي غير جراحي شائع يمنح شفتيك مظهرًا أكثر امتلاءً وتحديدًا. يعتمد هذا الإجراء على حقن كمية صغيرة من البوتوكس في العضلات المحيطة بالشفاه العلوية على عكس الفيلر التقليدي، مما يمنح الشفاه تقوّسًا طبيعيًا و مظهرًا ممتلئًا وأكثر جاذبية، دون أي زيادة في الحجم."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء بوتوكس قلب الشفاه",
            "para": "",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "تبدأ رحلتك مع جلسة استشارية شاملة مع أطباءنا الخبراء. نقوم بتقييم شكل شفتيك وبنية وجهك والنتيجة المرغوبة، لضمان أن بوتوكس قلب الشفاه هو الخيار الأمثل لك.",
                    "icon": "fa-regular fa-comment"
                },
                {
                    "title": "الاستعداد",
                    "desc": "يجد معظم المرضى أن الإجراء غير مؤلم تقريبًا، ولكن لضمان راحتك، تُنظف منطقة العلاج، وقد يُستخدم كريم مخدر عند الحاجة.",
                    "icon": "fa-regular fa-hand-sparkles"
                },
                {
                    "title": "حقن البوتوكس",
                    "desc": "يتم حقن جرعات صغيرة من البوتوكس باستخدام إبرة دقيقة جدًا في العضلات المحيطة بالشفاه العلوية. يساعد ذلك في إرخاء العضلات بلطف، مما يسمح للشفاه بـالتقوس للخارج لتبدو أكثر امتلاءً بشكل طبيعي.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "العناية بعد العلاج",
                    "desc": "قد يحدث احمرار طفيف أو تورم بسيط بعد الحقن، لكنه يزول عادةً في غضون ساعات قليلة. ستحصلين على إرشادات ما بعد العلاج لضمان أفضل النتائج والتعافي السريع.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد بوتوكس قلب الشفاه",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "نتائج طبيعية",
                    "desc": "يعزز شكل الشفاه بشكل دقيق دون إضافة فيلر، مما يمنحها مظهراً أكثر جمالاً طبيعيًا.",
                    "icon": "fa-regular fa-face-smile"
                },
                {
                    "title": "إجراء سريع",
                    "desc": "يستغرق العلاج بضع دقائق فقط، مما يجعله مثالياً لمن لديهم جدول مزدحم.",
                    "icon": "fa-regular fa-clock"
                },
                {
                    "title": "وقت تعافي قصير جدًا",
                    "desc": "قد يظهر احمرار أو تورم طفيف يزول خلال ساعات قليلة، مما يتيح العودة إلى الأنشطة اليومية فوراً.",
                    "icon": "fa-solid fa-bed"
                },
                {
                    "title": "خيار أكثر توفيرًا",
                    "desc": "يُعد بديلاً أقل تكلفة من الفيلر للأشخاص الذين يبحثون عن تجميل طفيف لمظهر الشفاه.",
                    "icon": "fa-solid fa-coins"
                }
            ]
        },
        "eligibility": {
            "heading": "معايير التأهل لبوتوكس قلب الشفاه",
            "subheading": "",
            "para": "يمكن لمعظم البالغين الذين يرغبون في تحسين طفيف لمظهر الشفاه إجراء بوتوكس قلب الشفاه، ولكن هناك بعض العوامل التي تجعل بعض الأشخاص أكثر ملاءمة لهذا الإجراء من غيرهم.",
            "items": [
                {
                    "title": "المرشح المثالي",
                    "desc": "الأشخاص الذين لديهم شفاه رفيعة ويرغبون في إبرازها بشكل طبيعي. الأشخاص الذين يعانون من الابتسامة اللثوية ويريدون تصحيحها. الأشخاص الذين يبحثون عن خيار غير جراحي ومؤقت لتجميل مظهر الشفاه.",
                    "icon": "fa-solid fa-user-check"
                },
                {
                    "title": "غير مناسب ل",
                    "desc": "البالغون الأصحاء الذين لا يعانون من حساسية تجاه البوتوكس. لا يُناسب الحامل أو المرضعة أو من يعانون من بعض الحالات الطبية التي يمكن أن تتعارض مع العلاج.",
                    "icon": "fa-solid fa-ban"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "التحضير لعملية بوتوكس قلب الشفاه سهل ولا يتطلب مجهودًا كبيرًا. إليك أهم التحضيرات اللازمة:",
            "items": [
                {
                    "title": "تجنب مميعات الدم",
                    "desc": "يُنصح بتجنب الأدوية المُميعة للدم مثل الأسبرين والإيبوبروفين لمدة لا تقل عن 48 ساعة قبل العلاج.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "تعديلات نمط الحياة",
                    "desc": "يجب الامتناع عن شرب الكحول وعن التدخين قبل الإجراء.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "الكشف عن الأدوية",
                    "desc": "يجب إبلاغ الطبيب بأي أدوية أو مكملات غذائية تتناولها.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "الحضور مستعدًا",
                    "desc": "يجب التأكد من أن الوجه نظيف وخالي تمامًا من المكياج عند الحضور للجلسة.",
                    "icon": "fa-solid fa-broom"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يمنح بوتوكس قلب الشفاه مظهرًا أكثر تحديدًا وجمالًا للشفاه العلوية مع نتائج دقيقة وفعالة. حيث يوفر الانحناء الخفيف للشفاه وزيادة امتلائها مظهرًا أكثر شبابًا.",
            "items": [
                {
                    "title": "المدة",
                    "desc": "تدوم النتائج عادةً من ثلاثة إلى أربعة أشهر.",
                    "icon": "fa-regular fa-calendar"
                },
                {
                    "title": "الصيانة",
                    "desc": "يجب تحديد جلسات متابعة للحفاظ على النتائج.",
                    "icon": "fa-solid fa-arrows-rotate"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح العناية بعد العلاج",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "تجنّب لمس المنطقة المُعالجة",
                    "desc": "تجنب لمس أو فرك أو تدليك المنطقة المعالجة لمدة لا تقل عن 24 ساعة، لمنع انتشار البوتوكس إلى عضلات غير المستهدفة.",
                    "icon": "fa-solid fa-hand-paper"
                },
                {
                    "title": "البقاء في وضع مستقيم",
                    "desc": "تجنب الانحناء أو الاستلقاء لمدة لا تقل عن أربع ساعات بعد الإجراء لضمان استقرار البوتوكس في المكان الصحيح.",
                    "icon": "fa-solid fa-person"
                },
                {
                    "title": "تجنب النشاط البدني المكثف",
                    "desc": "يُفضل الامتناع عن ممارسة التمارين الرياضية أو الأنشطة البدنية المجهدة خلال أول 24 ساعة للحد من خطر التورم أو الكدمات في مواضع الحقن.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "تجنب التعرض للحرارة",
                    "desc": "يفضل تجنب الاستحمام بالماء الساخن، أو الساونا، أو أي مصادر حرارة أخرى لمدة 24 ساعة، حيث يمكن أن تؤثر الحرارة على فعالية البوتوكس.",
                    "icon": "fa-solid fa-temperature-high"
                },
                {
                    "title": "الامتناع عن الكحول ومميعات الدم",
                    "desc": "ينصح بالابتعاد عن شرب الكحول أو تناول الأدوية المميعة للدم مثل الإيبوبروفين أو الأسبرين لمدة 24 ساعة لتقليل احتمالية ظهور الكدمات.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "يساعد شرب كميات كافية من الماء في عملية التعافي، ويحافظ على ترطيب الجسم بشكل مناسب.",
                    "icon": "fa-solid fa-glass-water"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة المكررة",
            "subheading": "",
            "items": [
                {
                    "question": "متى ستبدأ النتائج في الظهور؟",
                    "answer": "تبدأ نتائج بوتوكس قلب الشفاه بالظهور خلال 3 إلى 4 أيام، وتصبح النتائج كاملة بعد حوالي أسبوع."
                },
                {
                    "question": "هل يتطلب الإجراء فترة تعافي؟",
                    "answer": "لا، لا يتطلب فترة تعافي طويلة. قد تعاني من احمرار أو تورم خفيف، لكنه يختفي خلال بضع ساعات."
                },
                {
                    "question": "هل سيؤثر الإجراء على النطق أو تناول الطعام؟",
                    "answer": "لا، يستهدف بوتوكس قلب الشفاه عضلات محددة حول الشفاه ولن يؤثر على قدرتك على التحدث أو تناول الطعام أو الابتسام."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};
